<m-toast></m-toast>
@if (campaignsGlobalLoaderService.globalLoader.show) {
  <lib-ui-loader-global
    [loaderTitle]="campaignsGlobalLoaderService.globalLoader.title"
    [loaderMessage]="campaignsGlobalLoaderService.globalLoader.message"
    [view]="campaignsGlobalLoaderService.globalLoader.view"
    [closable]="
      campaignsGlobalLoaderService.globalLoader.view === 'success' ||
      campaignsGlobalLoaderService.globalLoader.view === 'error'
    "
    continueButtonLabel="Continue"
    loaderStyleClass="max-w-[25rem]"
    (handleContinue)="
      campaignsGlobalLoaderService.hideGlobalLoader()
    "></lib-ui-loader-global>
}
<div class="relative">
  <div class="absolute top-0 right-0 filter-context-wrapper w-[12rem] z-50">
    <m-dropdown
      styleClass="w-full"
      [options]="aiCampaignsViewService.dateRangeOptions"
      optionLabel="label"
      optionValue="value"
      placeholder="Select date range"
      [(ngModel)]="aiCampaignsViewService.selectedDateRange"
      [ngModelOptions]="{ standalone: true }"
      (formControlChange)="aiCampaignsViewService.handleDateRangeChange($event)"
      [appendTo]="'body'"></m-dropdown>
  </div>
  <m-tab-view
    [headerSize]="aiCampaignsViewService.headerSize"
    [tabPanelHeaders]="aiCampaignsViewService.campaignTabHeaders"
    (activeIndexChange)="aiCampaignsViewService.publishTabChange($event)"
    [activeIndex]="aiCampaignsViewService.activeTabIndex">
    @for (
      tab of aiCampaignsViewService.campaignTabHeaders;
      track tab;
      let index = $index
    ) {
      <ng-template [mTabIndex]="index + 1" #tabContent>
        <div class="flex flex-col gap-6 bg-gray-100">
          @if (
            aiCampaignsViewService.campaignCountsByType?.["underProcessing"]
              ?.metrics.length > 0 &&
            aiCampaignsViewService.activeTaxonomyTab !== "underProcessing"
          ) {
            <div
              class="flex justify-between items-center gap-x-4 p-[1rem] rounded border-s-4 border-y border-e border-solid border-y-blue-300 bg-blue-100 border-l-blue-700 border-r-blue-300">
              <div class="flex items-center">
                <span
                  class="material-symbols-outlined text-blue-600"
                  height="1.25rem"
                  width="1.25rem">
                  clock_loader_20
                </span>
              </div>
              <div class="text-gray-1000 b1 flex-1 items-center">
                Campaign mapping is in progress and will appear in the Mapped
                tab once complete.
              </div>
              <div
                class="b2 text-blue-600 cursor-pointer flex items-center"
                (click)="
                  aiCampaignsViewService.navigateToInProgressCampaigns()
                ">
                View
              </div>
            </div>
          }
          @for (card of aiCampaignsViewService.cardsToShow(); track card) {
            @if (
              campaignAccordionService.accordionStateByCampaignType[card]
                .loading ||
              (!campaignAccordionService.accordionStateByCampaignType[card]
                .loading &&
                (aiCampaignsViewService.campaignCountsByType[
                  card === "ai" ? "aiRecommended" : card
                ]?.metrics?.length > 0 ||
                  aiCampaignsViewService.campaignCountsByTypeActual[
                    card === "ai" ? "aiRecommended" : card
                  ]?.metrics?.length > 0))
            ) {
              <m-card>
                <div class="flex gap-4 justify-between">
                  <div
                    (click)="aiCampaignsViewService.handleTitleClick($event)">
                    <lib-ui-title
                      [titleConfigs]="
                        aiCampaignsViewService.titleConfigs[card]
                      "></lib-ui-title>
                  </div>
                  <div class="top-0 right-0 filter-context-wrapper">
                    <ng-container
                      *ngTemplateOutlet="
                        filterContext;
                        context: {
                          tab:
                            card === 'ai'
                              ? 'aiRecommended'
                              : aiCampaignsViewService.activeTaxonomyTab,
                        }
                      "></ng-container>
                  </div>
                </div>
                <div>
                  @if (
                    !campaignAccordionService.accordionStateByCampaignType[card]
                      .loading &&
                    aiCampaignsViewService.campaignCountsByType[
                      card === "ai" ? "aiRecommended" : card
                    ]?.metrics?.length > 0
                  ) {
                    <lib-taxonomy-campaign-accordion
                      [accordions]="
                        aiCampaignsViewService.campaignCountsByType[
                          card === 'ai' ? 'aiRecommended' : card
                        ]?.metrics
                      "
                      [activeTaxonomyTab]="
                        aiCampaignsViewService.activeTaxonomyTab
                      "
                      [requestInProgress]="
                        campaignAccordionService.accordionStateByCampaignType[
                          card
                        ].requestInProgress
                      "
                      [activeAccordionIndex]="
                        campaignAccordionService.accordionStateByCampaignType[
                          card
                        ].activeAccordionIndex
                      "
                      [groupByDimension]="
                        card === 'unmapped'
                          ? 'compositeDataSourceName'
                          : aiCampaignsViewService.filterContext
                              ?.groupByDimension
                      "
                      [geoTestStatusByDimension]="
                        aiCampaignsViewService.geoTestStatusByDimension
                      "
                      [clientId]="clientId()"
                      [brandId]="brandId()"
                      [activeAccordionDimensionValue]="
                        aiCampaignsViewService.activeAccordionDimensionValue
                      "
                      (activeIndexChange)="
                        aiCampaignsViewService.refreshCampaignRecords(
                          $any($event),
                          card === 'ai'
                        )
                      "
                      [loading]="
                        campaignAccordionService.accordionStateByCampaignType[
                          card
                        ].loading
                      "
                      [viewFor]="card"
                      [tableTemplate]="tableTemplate"
                      [dimensionUpdateTemplate]="dimensionUpdateTemplate">
                      <ng-template #tableTemplate>
                        <lib-taxonomy-campaign-table
                          [viewFor]="campaignTableService.viewFor"
                          [clientId]="clientId()"
                          [brandId]="brandId()"
                          (updateDimensionMapping)="
                            aiCampaignsViewService.showCampaignConfirmationDialog(
                              card,
                              $event
                            )
                          "
                          (applyAIRecommendations)="
                            aiCampaignsViewService.showCampaignConfirmationDialog(
                              card
                            )
                          ">
                        </lib-taxonomy-campaign-table>
                      </ng-template>
                      <ng-template #dimensionUpdateTemplate>
                        @if (
                          aiCampaignsViewService.activeAccordionDimensionValue
                        ) {
                          <lib-taxonomy-campaign-mapping-update-popover
                            class="self-stretch"
                            [clientId]="clientId()"
                            [brandId]="brandId()"
                            [selectedCampaignCount]="
                              campaignTableService.allCampaignsSelected
                                ? campaignTableService.campaignDimensionInfo
                                    ?.count
                                : campaignTableService.selectedCampaigns.length
                            "
                            [totalCampaigns]="
                              campaignTableService.campaignDimensionInfo?.count
                            "
                            [selectedCampaignType]="card"
                            [selectedDataSource]="
                              aiCampaignsViewService.activeAccordionDimensionValue
                            "
                            (updateDimensionMapping)="
                              aiCampaignsViewService.showCampaignConfirmationDialog(
                                card,
                                $event
                              )
                            "
                            (applyAIRecommendationsMapping)="
                              aiCampaignsViewService.showCampaignConfirmationDialog(
                                card,
                                $event
                              )
                            "
                            layout="vertical"
                            (actionStepChange)="
                              campaignTableService.changeActionStep($event)
                            "
                            [actionStep]="
                              campaignTableService.actionStep
                            "></lib-taxonomy-campaign-mapping-update-popover>
                        }
                      </ng-template>
                    </lib-taxonomy-campaign-accordion>
                  } @else if (
                    campaignAccordionService.accordionStateByCampaignType[card]
                      .loading
                  ) {
                    <div class="flex flex-col w-full gap-4">
                      <m-skeleton
                        *ngFor="let i of [1, 2, 3, 4, 5]"
                        height="4rem"
                        width="100%"
                        class="w-full"
                        styleClass="w-full"></m-skeleton>
                    </div>
                  }
                </div>
              </m-card>
            }
          }
          <ng-template #filterContext let-tab="tab">
            <lib-taxonomy-campaign-view-filter-context
              [activeTab]="tab"
              [campaignViewColumns]="
                aiCampaignsViewService.columnsForColumnSelector
              "
              filterView="ai"
              [groupByDimension]="
                aiCampaignsViewService.filterContext.groupByDimension
              "
              (campaignFilterChange)="
                aiCampaignsViewService.refreshCampaignView($event, tab)
              "
              (approveAll)="
                aiCampaignsViewService.showCampaignConfirmationDialog(
                  tab === 'aiRecommended' ? 'ai' : tab,
                  { action: 'approveAll' }
                )
              "></lib-taxonomy-campaign-view-filter-context>
          </ng-template>

          @if (
            !campaignAccordionService.accordionStateByCampaignType[
              aiCampaignsViewService.activeTaxonomyTab
            ].loading &&
            !campaignAccordionService.accordionStateByCampaignType["ai"]
              .loading &&
            ((aiCampaignsViewService.activeTaxonomyTab === "unmapped" &&
              !aiCampaignsViewService.campaignCountsByType[
                aiCampaignsViewService.activeTaxonomyTab
              ]?.metrics.length &&
              !aiCampaignsViewService.campaignCountsByType["aiRecommended"]
                ?.metrics.length) ||
              (aiCampaignsViewService.activeTaxonomyTab !== "unmapped" &&
                !aiCampaignsViewService.campaignCountsByType[
                  aiCampaignsViewService.activeTaxonomyTab
                ]?.metrics.length))
          ) {
            <m-not-available
              [noDataState]="campaignAccordionService.noData"
              [title]="
                campaignAccordionService.tabWiseNoDataMessages[
                  aiCampaignsViewService.activeTaxonomyTab
                ].title
              "
              [description]="
                campaignAccordionService.tabWiseNoDataMessages[
                  aiCampaignsViewService.activeTaxonomyTab
                ].description
              "></m-not-available>
          }
        </div>
      </ng-template>
    }
  </m-tab-view>
  <m-modal
    [(visible)]="campaignsConfirmationPopupService.confirmationDialog.show"
    [modal]="true"
    [closable]="true"
    [showHeader]="true"
    [showFooter]="true"
    [draggable]="false"
    (onHide)="campaignsConfirmationPopupService.hideDialog()">
    <div modalHeader class="flex w-full items-center">
      <span class="h5 text-gray-1000">{{
        campaignsConfirmationPopupService.title
      }}</span>
    </div>
    <div class="flex flex-col w-full items-center p-6 gap-y-4">
      <span
        class="b1 text-gray-1000 w-[31rem]"
        [innerHTML]="
          campaignsConfirmationPopupService.confirmationDialog
            .confirmationMessage
        ">
      </span>
      @if (aiCampaignsViewService.showGeoTestWarning()) {
        <span
          class="b1 text-gray-1000 w-[31rem] p-4 bg-yellow-100 border-e border-y border-solid border-y-yellow-300 border-r-yellow-300 border-s-4 border-l-orange-300">
          <span class="text-gray-1000 b1 gap-x-4 flex items-center gap-x-4">
            <span class="material-symbols-outlined text-orange-300">
              warning
            </span>
            <span class="text-gray-1000 b1">
              Some of the selected campaigns are involved in ongoing geo tests.
              Adjusting their mapping may impact test results.
            </span>
          </span>
        </span>
      }
    </div>
    <div modalFooter class="flex w-full items-center justify-end gap-4">
      <m-button
        type="secondary"
        styleClass="m-0"
        (click)="aiCampaignsViewService.cancelCampaignMapping()">
        <span class="b2">Cancel</span>
      </m-button>
      <m-button
        type="primary"
        styleClass="m-0"
        (click)="aiCampaignsViewService.approveCampaignMapping()">
        @if (
          ["approve", "approveAll"].includes(
            campaignsConfirmationPopupService.action
          )
        ) {
          <span class="b2">Approve</span>
        } @else {
          <span class="b2">Proceed</span>
        }
      </m-button>
    </div>
  </m-modal>

  <m-modal
    [(visible)]="aiCampaignsViewService.showLearnMoreModal"
    [modal]="true"
    [closable]="true"
    [showHeader]="true"
    [showFooter]="true"
    [draggable]="false"
    (onHide)="aiCampaignsViewService.showLearnMoreModal = false"
    styleClass="w-[32rem]">
    <div modalHeader class="flex flex-col w-full items-center gap-6">
      <div>
        <span class="h5 text-gray-1000">How does AI mapping work?</span>
      </div>
      <div class="flex flex-row w-full gap-4 items-center">
        <div
          class="flex items-center justify-center bg-blue-100 text-blue-600 rounded-full w-[3rem] h-[3rem] gap-x-4">
          <div class="flex w-[20px] h-[20px]">
            <img
              src="assets/sparkles-blue.svg"
              alt="AI sparkles icon"
              class="w-full h-full" />
          </div>
        </div>
        <div class="b1 text-gray-1000 flex-1">
          Our AI-recommended mapping is powered by machine learning based on
          your past data.
        </div>
      </div>
      <div class="flex flex-row w-full gap-4 items-center">
        <div
          class="flex items-center justify-center bg-blue-100 text-blue-600 rounded-full w-[3rem] h-[3rem] gap-x-4">
          <span class="material-symbols-outlined text-xl"> search_check </span>
        </div>
        <div class="b1 text-gray-1000 flex-1">
          It identifies the most accurate tactic, channel, and segment mappings
          for your campaigns.
        </div>
      </div>
      <div class="flex flex-row w-full gap-4 items-center">
        <div
          class="flex items-center justify-center bg-blue-100 text-blue-600 rounded-full w-[3rem] h-[3rem] gap-x-4">
          <span class="material-symbols-outlined"> edit </span>
        </div>
        <div class="b1 text-gray-1000 flex-1">
          If anything looks off, you can easily adjust the recommendations
          either before confirming or even after the campaigns are mapped.
        </div>
      </div>
    </div>
  </m-modal>
</div>
